/* tslint:disable */
/* eslint-disable */
/**
 * Swagger wiegaaterkoffiehalen
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AppCheck,
    AppCheckFromJSON,
    AppCheckToJSON,
} from '../models/AppCheck';

/**
 * 
 */
export class GeneralApi extends runtime.BaseAPI {

    /**
     * Creates request options for appCheck without sending the request
     */
    async appCheckRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/appcheck`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get minimum app version
     */
    async appCheckRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppCheck>> {
        const requestOptions = await this.appCheckRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppCheckFromJSON(jsonValue));
    }

    /**
     * Get minimum app version
     */
    async appCheck(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppCheck> {
        const response = await this.appCheckRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getVersion without sending the request
     */
    async getVersionRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/version`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the version from package.json as a plain string (e.g. `2.2.1`).
     * Get backend version
     */
    async getVersionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.getVersionRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Returns the version from package.json as a plain string (e.g. `2.2.1`).
     * Get backend version
     */
    async getVersion(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getVersionRaw(initOverrides);
        return await response.value();
    }

}
